export default "__VITE_ASSET__ZlkUIebR__"